import { useTranslations } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/contexts/TranslationContext";
import { Icon } from "@/components/ui/Icon";

export const PoweredBy = () => {
  const t = useTranslations();

  return (
    <div className="PoweredBy flex w-full items-center justify-center gap-1 bg-[--color500] py-1 text-xs text-[--contrastText] dark:bg-[--color500]">
      <Icon icon="dp-custom-deskpro" />
      <span className="font-semibold">
        <a
          href="https://www.deskpro.com/powered-by-deskpro/messenger"
          className="no-underline hover:text-[--color100]"
          target="_blank"
        >
          {t("Footer.powered_by_deskpro")}
        </a>
      </span>
    </div>
  );
};
